import React from "react";
import styled from "styled-components";
import { CircularProgress, Box, Stack } from "@mui/material";

import { PADDING, THEME } from "styles";

type CommonLayoutProps = React.PropsWithChildren<{
  loading?: boolean;
  style?: React.CSSProperties;
}>;

const CommonContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const CommonLayout = React.forwardRef<HTMLDivElement, CommonLayoutProps>(
  (props, ref) => {
    const { children, loading, style } = props;

    return (
      <CommonContainer ref={ref} style={style}>
        {loading ? (
          <Box
            sx={{
              width: "100wv",
              height: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          children
        )}
      </CommonContainer>
    );
  }
);

const StyledBottomContainer = styled.div`
  width: 100%;
  height: 70px;
  flex-shrink: 0;

  display: flex;
  flex-direction: row;
  align-items: center;

  gap: 16px;
  padding: 0 24px;
  border-top: 1px solid ${THEME.border};
`;

export const BottomContainer = ({
  style,
  children,
}: React.PropsWithChildren<{ style?: React.CSSProperties }>) => {
  return (
    <StyledBottomContainer style={style}>{children}</StyledBottomContainer>
  );
};

const ScrollContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  /* align-items: center; */

  overflow-y: auto;
`;

export const ScrollableContentContainer = React.forwardRef<
  HTMLDivElement,
  React.PropsWithChildren<{
    style?: React.CSSProperties;
    contentContainer?: React.CSSProperties;
  }>
>(({ style, children, contentContainer }, ref) => {
  return (
    <ScrollContainer ref={ref} style={style}>
      <Stack
        flex={1}
        width={"100%"}
        alignSelf="center"
        flexDirection="column"
        style={{ maxWidth: "1480px", ...contentContainer }}
        sx={(theme) => ({
          padding: "40px 80px 40px 40px",

          [theme.breakpoints.between("mobileXs", "tabletXs")]: {
            padding: "24px 32px 24px 24px",
          },

          [theme.breakpoints.down("mobileXs")]: {
            padding: 0,
          },
        })}
      >
        {children}
      </Stack>
    </ScrollContainer>
  );
  // return (
  //   <ScrollContainer ref={ref} style={style}>
  //     <div className="scroll-content-container" style={contentContainer}>
  //       {children}
  //     </div>
  //   </ScrollContainer>
  // );
});

const StyledContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${PADDING.default};
  gap: ${PADDING.medium};
  overflow: hidden;
`;

export const ContentContainer = ({
  style,
  children,
}: React.PropsWithChildren<{
  style?: React.CSSProperties;
}>) => {
  return (
    <StyledContentContainer style={style}>{children}</StyledContentContainer>
  );
};

const StyledCommonContentLayout = styled.div`
  width: 100%;
  height: 100%;
  padding: 40px 80px 40px 40px;

  display: flex;
  flex-direction: column;
`;

export const CommonContentLayout = ({
  children,
}: React.PropsWithChildren<unknown>) => {
  return <StyledCommonContentLayout>{children}</StyledCommonContentLayout>;
};
